import _extends from "@babel/runtime/helpers/esm/extends";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { ICON_SIZE_OPTIONS } from '../../utils/constants';
import { transformIconProps } from '../../utils/icons';
var IconUiClose = function IconUiClose(props) {
  return jsx("svg", _extends({
    width: "16",
    height: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, transformIconProps(props)), jsx("path", {
    d: "M2.667 2.667l10.666 10.666M13.333 2.667L2.667 13.333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export { IconUiClose };